var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "x2dbh3aqua"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.333333 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vmgxkwt88b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.050980 0 0 0 0 0.098039 0 0 0 0 0.121569 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#x2dbh3aqua)",
    transform: "translate(-1123 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#vmgxkwt88b)",
    transform: "translate(1123 40)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.779 7.027L4.699 7.027.7 3.847 4.699.7 21.779.7zM18 .939L18 6.433M5.272.939L5.272 6.433",
    transform: "translate(0 1) rotate(-45 21.864 8.5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPlan);
export default __webpack_public_path__ + "static/media/edit-plan.74d820bdfeb81b293af699dec25eedb3.svg";
export { ForwardRef as ReactComponent };